import {booleanAttribute, ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core'
import {UntypedFormControl, Validators} from '@angular/forms'
import {faLockAlt} from '@fortawesome/pro-solid-svg-icons/faLockAlt'
import {faPaperPlane} from '@fortawesome/pro-solid-svg-icons/faPaperPlane'
import {faPhone} from '@fortawesome/pro-solid-svg-icons/faPhone'
import {AlternativeCallToAction, SendMessageEvent, SendMessageFields} from './contact-form-card.types'
import {TypedFormControls, TypedFormGroup} from '../../core/forms/form-controls.model'
import {BehaviorSubject, Observable, Subject, timer} from 'rxjs'
import {ButtonFeedback} from '../button/button/button.component'

@Component({
  selector: 'cft-contact-form-card',
  templateUrl: './contact-form-card.component.html',
  styles: [':host { display: block }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ContactFormCardComponent {
  @Input({transform: booleanAttribute}) elevated = true
  @Input() alternativeCallToAction!: AlternativeCallToAction
  @Input() dataPrivacyLink!: string
  @Output() sendMessage = new EventEmitter<SendMessageEvent>()

  readonly controls: TypedFormControls<SendMessageFields> = {
    firstAndLastName: new UntypedFormControl(undefined, [Validators.required]),
    email: new UntypedFormControl(undefined, [Validators.required, Validators.email]),
    phoneNumber: new UntypedFormControl(),
    message: new UntypedFormControl(undefined, [Validators.required]),
  }
  readonly form = new TypedFormGroup<SendMessageFields>(this.controls)
  readonly lockIcon = faLockAlt
  readonly submitIcon = faPaperPlane
  readonly phoneIcon = faPhone
  readonly isSuccessful = new BehaviorSubject<ButtonFeedback>(ButtonFeedback.None)
  readonly isSuccessful$: Observable<ButtonFeedback> = this.isSuccessful.asObservable()
  readonly isLoading = new Subject<boolean>()
  readonly isLoading$ = this.isLoading.asObservable()
  readonly ButtonFeedback = ButtonFeedback

  submit(): void {
    this.form.markAllAsTouched()
    if (this.form.invalid) {
      return
    }

    this.isLoading.next(true)
    this.sendMessage.emit({
      fields: this.form.value,
      done: this.messageSent.bind(this),
    })
  }

  messageSent(): void {
    this.isLoading.next(false)
    this.isSuccessful.next(ButtonFeedback.Success)
    this.form.reset()
    timer(5000).subscribe(() => this.isSuccessful.next(ButtonFeedback.None))
  }
}
